import { Text } from "@utils/helper";
import { forwardRef, useMemo } from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";
import useTranslation from "next-translate/useTranslation";
import { useSelector } from "noval";
import { buildClass } from "@utils/tag";
import { inputSvc } from "./inputSvc";

const FieldInput = forwardRef(
  (
    {
      customLabel,
      classNameLabel,
      regularLabel,
      clsName,
      name,
      renderChild,
      sx = {},
      className,
      helperText,
      error,
      onChange,
      removeText,
      maxDigits,
      changeCallback,
      inputConstrains = {},
      inputBg = "#F8FBFF",
      fontFamily,
      inputStyles,
      showPassword,
      inputSize,
      removeSpaces,
      formatNumber,
      removeOuterText,
      removeNumbers,
      ...otherProps
    },
    ref
  ) => {
    const { lang } = useTranslation();
    const screen = useSelector("screen");

    const servicesPriority = [
      { key: "removeText", condition: removeText },
      { key: "removeOuterText", condition: removeOuterText },
      { key: "removeSpaces", condition: removeSpaces },
      { key: "formatNumber", condition: formatNumber },
      { key: "removeNumbers", condition: removeNumbers },
    ];

    const activeService =
      servicesPriority.find((service) => service.condition)?.key || "default";

    const getFontFamily = useMemo(
      () =>
        fontFamily
          ? otherProps.value && !showPassword
            ? fontFamily
            : "inherit"
          : "inherit",
      [fontFamily, otherProps.value, showPassword]
    );

    return (
      <div className={`flex flex-col gap-3 w-full ${clsName}`}>
        {customLabel ? (
          <Text
            fontType={!regularLabel && "Expo_sim"}
            weight={!regularLabel && 500}
            className={buildClass(
              "!text-[14px] md:!text-[16px]",
              classNameLabel
            )}
          >
            {customLabel}
          </Text>
        ) : null}
        <FormControl fullWidth error={Boolean(error)}>
          <div className="flex gap-3 w-full">
            {renderChild ? renderChild : null}
            <TextField
              inputProps={inputConstrains}
              name={name}
              inputRef={ref}
              variant="outlined"
              fullWidth
              sx={{
                "& MuiInputBase-input , .MuiOutlinedInput-input": {
                  fontSize: inputSize ?? "inherit",
                },
                "& fieldset": {
                  border: "none",
                },
                "& .MuiInputBase-input::placeholder": {
                  fontSize: screen === "sm-phone" ? "12px" : "16px",
                  fontFamily: "Expo_bok",
                  fontWeight: 400,
                },
                "& .MuiOutlinedInput-root": {
                  fontFamily: getFontFamily + " !important",
                  fontSize: getFontFamily === fontFamily ? "32px" : "inherit",
                  height: "56px",
                  lineHeight: "1.5",
                  ...inputStyles,
                },
                boxShadow: "none !important",
                background: inputBg,
                border: "none",
                ...sx,
              }}
              className={`rounded-lg !shadow ${className}`}
              onChange={(e) => {
                const { value } = e.target;
                inputSvc(
                  value,
                  (newValue) => {
                    e.target.value = newValue;
                    onChange(e);
                  },
                  changeCallback,
                  activeService,
                  { maxDigits }
                );
              }}
              {...otherProps}
            />
          </div>
          <FormHelperText
            style={{
              textAlign: lang === "en" ? "left" : "right",
              marginLeft: "0",
              marginRight: "0",
              marginTop: helperText ? "3px" : "0",
            }}
            className="px-[14px] pt-2"
            dir="auto"
          >
            {helperText}
          </FormHelperText>
        </FormControl>
      </div>
    );
  }
);

FieldInput.displayName = "FieldInput";

export default FieldInput;
